import { createTheme } from "@mui/material"

import { BASE_THEME_CONFIG } from "./baseTheme"
import {
    DARK_THEME_BG_GREY_ONE,
    DARK_THEME_BG_GREY_TWO,
    ENA_CYAN_100,
    ENA_CYAN_20,
    ENA_ORANGE_100,
    ENA_ORANGE_20,
    ERROR_DARK,
    ERROR_LIGHT,
    ERROR_MAIN,
    SUCCESS_DARK,
    SUCCESS_LIGHT,
    SUCCESS_MAIN,
    WARNING_DARK,
    WARNING_LIGHT,
    WARNING_MAIN,
    WHITE,
} from "./colours"
import { responsiveTypography } from "./typography"

const darkTheme = createTheme({
    palette: {
        mode: "dark",
        background: {
            frameBackground: DARK_THEME_BG_GREY_TWO,
            contentBackground: DARK_THEME_BG_GREY_ONE,
            successBackground: "#EDF7ED",
            paper: DARK_THEME_BG_GREY_TWO,
        },
        text: {
            primary: WHITE,
        },
        primary: {
            main: ENA_CYAN_100,
            light: ENA_CYAN_20,
            contrastText: WHITE,
        },
        secondary: {
            main: ENA_ORANGE_100,
            light: ENA_ORANGE_20,
            contrastText: WHITE,
        },
        success: {
            main: SUCCESS_MAIN,
            light: SUCCESS_LIGHT,
            dark: SUCCESS_DARK,
            contrastText: WHITE,
        },
        error: {
            main: ERROR_MAIN,
            light: ERROR_LIGHT,
            dark: ERROR_DARK,
            contrastText: WHITE,
        },
        warning: {
            main: WARNING_MAIN,
            light: WARNING_LIGHT,
            dark: WARNING_DARK,
            contrastText: WHITE,
        },
    },
    ...BASE_THEME_CONFIG,
})

export default responsiveTypography(darkTheme)
